import { Season } from '../../../../corelogic/domain/models/season.model';
import { isSameDay } from '../../../../corelogic/domain/utils/date.utils';
import { getSeasons } from '../../../../corelogic/state/season/season.selector';
import { retrieveSeasonFights } from '../../../../corelogic/state/seasonFights/seasonFights.action';
import {
  getLastUpdated,
  getSeasonFights,
  getSeasonFightsLoading,
  getSeasonId,
} from '../../../../corelogic/state/seasonFights/seasonFights.selector';
import { store } from '../../../../corelogic/state/store';

export const SeasonFightsService = {
  // Internal function to check if the data is stale
  isDataStale(seasonId: string): boolean {
    const lastUpdated = getLastUpdated(store.getState());
    const currentSeasonId = getSeasonId(store.getState());
    const currentSeasonFights = getSeasonFights(store.getState());

    // If we're asking for the same season and we have data
    if (
      currentSeasonId === seasonId &&
      currentSeasonFights &&
      currentSeasonFights.length > 0
    ) {
      // We have data for this season - check if it's recent enough
      const isDataRecent = lastUpdated && isSameDay(lastUpdated, Date.now());
      return !isDataRecent;
    }

    // If we're asking for a different season, or we have no data, it's stale
    const needsNewData =
      !currentSeasonFights ||
      currentSeasonFights.length === 0 ||
      currentSeasonId !== seasonId;

    return needsNewData;
  },

  retrieveSeasonFights: (seasonId: string) => {
    // First check if already loading to prevent race conditions
    const isCurrentlyLoading = getSeasonFightsLoading(store.getState());
    const currentSeasonId = getSeasonId(store.getState());

    if (isCurrentlyLoading && currentSeasonId === seasonId) {
      return;
    }

    const seasons = getSeasons(store.getState());
    const selectedSeasonData = seasons.find(
      (season: Season) => season.seasonId === seasonId,
    );

    if (!selectedSeasonData) {
      return;
    }

    if (SeasonFightsService.isDataStale(seasonId)) {
      store.dispatch(
        retrieveSeasonFights({
          seasonId,
          startDate: new Date(selectedSeasonData.startDate),
          endDate: new Date(selectedSeasonData.endDate),
          retry: 0,
        }),
      );
    }
  },
};
